import axios from 'axios'
import { BUSCAR_DETALHAMENTO_FINANCEIRO_ENCOMENDA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarDetalhamentoFinanceiroEncomenda (idItinerario, idEmpresa) {
  const url = `${URL}/encomendas/${idItinerario}/empresa/${idEmpresa}/detalhamento-financeiro-encomenda`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_DETALHAMENTO_FINANCEIRO_ENCOMENDA ,
        payload: response

      })
  );
}
